import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ShippingLineModalService {

  private selectedShippingLineSubject = new BehaviorSubject<any>(null);
  public selectedShippingLine$ = this.selectedShippingLineSubject.asObservable();

  constructor() { }

  setSelectedShippingLine(shippingLine: any): void {
    this.selectedShippingLineSubject.next(shippingLine);
  }

  getSelectedShippingLine(): any | null {
    return this.selectedShippingLineSubject.value;
  }

  clearSelectedShippingLine(): void {
    this.selectedShippingLineSubject.next(null);
  }
}
